export default "__VITE_ASSET__CfwAQOaQ__"